module.exports = __webpack_public_path__ + "static/mycuddy-8517dd8d6fa507418922912c3fcc0dbf.png";